import React from 'react';
import CheckoutSummaryHeader from '../../Cart/CheckoutSummaryHeader';
import NavHeader from '../../Cart/NavHeader';
import styles from '../../Cart/Root/styles.module.scss';
import SubmissionFailurePanel from '../SubmissionFailurePanel';

export const SubmissionFailure = props => {
  return (
    <div className={styles.cartDashboard}>
      <NavHeader />
      <CheckoutSummaryHeader />
      <SubmissionFailurePanel history={props.history} />
    </div>
  );
};

export default SubmissionFailure;
